import DrugInfo from './DrugInfo'
export default DrugInfo
